import { getOrdersReviewOrderOrderId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { useQuery } from "@tanstack/react-query";

export const ORDER_PARTNER_REVIEW = "ORDER_PARTNER_REVIEW";

export const getOrderPartnerReviewByOrderIdQueryKey = (orderId?: number) => {
	return [ORDER_PARTNER_REVIEW, orderId];
};

export function usePartnerReviewByOrderIdQuery(orderId?: number) {
	return useQuery({
		queryKey: getOrderPartnerReviewByOrderIdQueryKey(orderId),
		queryFn: processResponse(() => getOrdersReviewOrderOrderId(orderId!)),
		retry: false,
		retryOnMount: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled:
			!!orderId && hasPermission(UserPermissions.OrderPartnerReviewModule.read),
	});
}
